export abstract class StatusCodeError extends Error {
  statusCode: number;

  protected constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
}
